// Shared route constants for the 30 programmatic location pages.
// Kept in a dependency-free module so App.js can build routes without
// eagerly importing the (lazy-loaded) page components.

export const CITIES = {
  mumbai: "Mumbai",
  hyderabad: "Hyderabad",
  ahemdabad: "Ahmedabad",
  pune: "Pune",
  delhi: "Delhi",
};

// URL prefixes exactly as per the Page URL - Location mapping sheet
export const PRODUCT_PREFIXES = {
  econsent: "best-electronic-consent-management-system-in-",
  epro: "best-electronic-patient-reported-outcomes-software-in-",
  rtsm: "best-interactive-web-response-system-in-",
  telehealth: "best-video-consultation-module-for-clinical-trials-in-",
  ptm: "best-clinical-trial-participant-tracker-software-in-",
};
